import React, { useState } from 'react';
import clsx from 'clsx';
import SingleBranchLoadable from './SingleBranchLoadable';
import TimingsContacts from './TimingsContacts';
import GoogleMapReact from 'google-map-react';
import SingleLocationPin from './SingleLocationPin';
import { getDirection } from './helper';

const arrowRedForward = '/-/media/Project/FAB2/Fab2/data/media/svgs/icons/icon-arrow-left';
const arrowDownForward = '/-/media/Project/FAB2/Fab2/data/media/svgs/icons/icon-arrow-down-blue';
const iconRedCheck = '/-/media/Project/FAB2/Fab2/data/media/svgs/icons/icon-red-check';

const SingleFacility = ({ icon, data }) => {
  return data.map((item, index) => {
    return (
      !!item?.fields?.facility?.value && (
        <div key={index} className="single-facility">
          <img src={icon} alt="checkmark" />
          <span>{item.fields.facility.value}</span>
        </div>
      )
    );
  });
};

const LeftSideComponent = ({
  leftSideComponentToggle,
  setLeftSideComponentToggle,
  t,
  data = {},
  fields = {},
  params,
  i18n,
}) => {
  const facilities = data?.fields?.facilities;
  const disabledFacilities = data?.fields?.disabledFacilities;
  const items = data?.fields?.items;

  const shouldRenderFacilities = Array.isArray(facilities) && facilities.length > 0;
  const shouldRenderDisabledFacilities =
    Array.isArray(disabledFacilities) && disabledFacilities.length > 0;
  const shouldRenderItems = Array.isArray(items) && items.length > 0;

  const arrowBackClick = () => {
    setLeftSideComponentToggle(false);
  };

  /**
   * 0 -> available
   * 1 -> disability
   */
  const [selectedTab, setSelectedTab] = useState(0);

  const onTabClick = (index) => {
    setSelectedTab(index);
  };

  const mapClick = () => {
    const res = getDirection(false, fields, data?.fields?.longitude, data?.fields?.latitude);
    if (res) {
      window.open(res, '_blank');
    }
  };

  const [toggleFacilitiesTabs, setToggleFacilitiesTabs] = useState(false);

  return (
    <div className={clsx('left-side-container', leftSideComponentToggle && 'toggle')}>
      <div onClick={arrowBackClick} className="back-container">
        <img className="back-arrow" src={arrowRedForward} alt="red-arrow" />
        <span>{t('back')}</span>
      </div>
      {data?.fields && (
        <div className="left-side-content">
          <div className="left-side-content_top">
            <SingleBranchLoadable
              withCta={false}
              withDirection={true}
              data={data.fields}
              t={t}
              fields={fields}
              params={params}
              i18n={i18n}
            />
          </div>
          <div className="left-side-content_map">
            <GoogleMapReact
              onClick={mapClick}
              zoom={16}
              defaultCenter={{
                lng: fields?.mapCenterLongitude?.value,
                lat: fields?.mapCenterLatitude?.value,
              }}
              center={
                !!data?.fields?.latitude?.value && !!data?.fields?.longitude?.value
                  ? {
                      lat: data.fields.latitude.value,
                      lng: data.fields.longitude.value,
                    }
                  : []
              }
            >
              <SingleLocationPin
                lat={data?.fields?.latitude?.value}
                lng={data?.fields?.longitude?.value}
                data={data}
                justPin={true}
              />
            </GoogleMapReact>
          </div>
          <div className="left-side-content_bottom">
            {shouldRenderItems && <TimingsContacts data={items} t={t} />}
            {(shouldRenderFacilities || shouldRenderDisabledFacilities) && (
              <div className="facilites-container">
                <div className="facilites-tabs">
                  {shouldRenderFacilities && (
                    <div
                      onClick={() => onTabClick(0)}
                      className={clsx('facilities-tab', selectedTab === 0 && 'selected')}
                    >
                      {t('availableFacilities')}
                    </div>
                  )}
                  {shouldRenderDisabledFacilities && (
                    <div
                      onClick={() => onTabClick(1)}
                      className={clsx('facilities-tab', selectedTab === 1 && 'selected')}
                    >
                      {t('disabilityFacilities')}
                    </div>
                  )}
                </div>
                <div className="facilities-tabs--mobile">
                  <div className="facilities-tab selected">
                    {selectedTab === 0 ? t('availableFacilities') : t('disabilityFacilities')}
                  </div>
                  <div
                    className={clsx('facility-selection', toggleFacilitiesTabs && 'toggled')}
                    onClick={() => setToggleFacilitiesTabs((prev) => !prev)}
                  >
                    <img src={arrowDownForward} alt="arrow" />
                  </div>
                </div>
                <div
                  onClick={() => {
                    setToggleFacilitiesTabs(false);
                    selectedTab === 0 ? setSelectedTab(1) : setSelectedTab(0);
                  }}
                  className={clsx('facilities-options', toggleFacilitiesTabs && 'toggled')}
                >
                  {selectedTab === 0 ? t('disabilityFacilities') : t('availableFacilities')}
                </div>
                {shouldRenderFacilities && selectedTab === 0 && (
                  <div className="facility-container">
                    <SingleFacility icon={iconRedCheck} data={facilities} />
                  </div>
                )}
                {shouldRenderDisabledFacilities && selectedTab === 1 && (
                  <div className="facility-container">
                    <SingleFacility icon={iconRedCheck} data={disabledFacilities} />
                  </div>
                )}
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default LeftSideComponent;
